import React, { useEffect } from "react";
import "./assets/scss/style.scss";
import 'react-loading-skeleton/dist/skeleton.css'
import Routing from "./Routes";
import { useDispatch, useSelector } from "react-redux";
import { changeAuthenticated } from "Slices/theme/reducer";
import { RootState } from "Slices/theme/store";
import { Toaster } from "react-hot-toast";
import Cookies from 'js-cookie';


function App() {
  const isAuthenticated = useSelector(
    (state: RootState) => state.theme.isAuthenticated
  );
  const dispatch = useDispatch();

  useEffect(() => {
    const token = Cookies.get("token");
    if (token) {
      dispatch(changeAuthenticated(true));
    }
  }, [isAuthenticated]);

  return (
    <>
      <Routing />
      <Toaster position="top-center" reverseOrder={false} />
    </>
  );
}

export default App;
